<script setup lang="ts">
const { t, locale } = useI18n();

const firstName = defineModel("firstName", { type: String, required: true });
const lastName = defineModel("lastName", { type: String, required: true });
const mobile = defineModel("mobile", { type: String, required: true });
const businessEmail = defineModel("businessEmail", { type: String, required: true });
const selectedCountry = defineModel("selectedCountry", { type: Object, required: true });
</script>

<template>
  <div class="flex flex-col justify-center items-center space-y-1 lg:space-y-3">
    <h2 class="text-default-500 font-bold text-center text-2xl lg:text-[40px] leading-[30px] lg:leading-[46px]">
      {{ t('page.create_business.business_owner.title') }}</h2>
    <span class="text-overcast-night font-medium text-wrap text-center text-sm lg:text-lg">{{
        t('page.create_business.business_owner.desc')
      }}</span>
  </div>
  <div class="flex-1 flex flex-col space-y-3 gap-y-2 mt-10 w-full">
    <div class="flex space-x-4 w-full *:flex-1 rtl:space-x-reverse">
      <UFormGroup :label="t('name.first_name')" name="first_name" size="xl">
        <UInput v-model="firstName" type="text" :placeholder="t('placeholder.first_name')" size="xl" />
      </UFormGroup>
      <UFormGroup :label="t('label.last_name')" :hint="t('optional')" name="last_name" size="xl">
        <UInput v-model="lastName" type="text" :placeholder="t('placeholder.last_name')" size="xl" />
      </UFormGroup>
    </div>
    <UFormGroup :label="t('label.email_address')" name="business_email" size="xl">
      <UInput v-model="businessEmail" type="text" dir="ltr" :class="{'placeholder-right': locale === 'ar'}" placeholder="e.g. johndoe@example.com" size="xl" />
    </UFormGroup>
    <UFormGroup :label="t('label.mobile_number')" name="mobile" size="xl" dir="ltr" :ui="{label: {base: 'block w-full rtl:text-right'}}">
      <UInput v-model="mobile" type="text" placeholder="1234 5678" inputmode="numeric" :ui="{ leading: { padding: {xl: 'ps-22'} } }">
        <template #leading>
          <div class="flex items-center space-x-2">
            <img class="size-6 rounded-md" :src="selectedCountry?.image" :alt="selectedCountry?.name" >
            <span class="text-sm">+{{ selectedCountry?.dialing_code }}</span>
          </div>
        </template>
      </UInput>
    </UFormGroup>
  </div>
</template>
